import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const AlertWarning: React.FC<Props> = ({
  accessibilityLabel,
  className,
}) => (
  <i className={cx(styles.icon, className)}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      {...iconAccessibility(accessibilityLabel)}
    >
      <path
        d='M12.75 9v5h-1.5V9h1.5zM12 17a1 1 0 100-2 1 1 0 000 2z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.995 3.242a1.75 1.75 0 00-1.513.87v.002L2.874 17.108l-.001.002a1.75 1.75 0 001.52 2.64h15.213a1.75 1.75 0 001.52-2.64l-.002-.002L13.51 4.114l-.001-.002a1.75 1.75 0 00-1.513-.87zm-.125 1.533a.25.25 0 01.341.091l7.622 13.003.002.003a.25.25 0 01-.218.378H4.383a.25.25 0 01-.218-.378L11.777 4.87l.002-.003a.25.25 0 01.091-.09z'
        fill='currentColor'
      />
    </svg>
  </i>
);

AlertWarning.displayName = 'AlertWarning';
export default AlertWarning;
